import React from "react";
import classnames from "classnames";
import './styles.scss';

const component = ({isButtonGroupCta, children, className}) => {
  const mergedClassName = classnames("up-next-content-section", {
    'up-next-content-section--button-group-cta': isButtonGroupCta
  }, className);

  return (
    <div className={mergedClassName}>
      {children}
    </div>
  );
}

component.displayName = 'UpNextContentSection';
export default component;


// WEBPACK FOOTER //
// ./client/components/UpNextContentSection/index.js